import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import {
  beforeEachRoute
} from './globalNavigationGuards';
import loginRoute from './routes/loginRoute/loginRoute';
import notFoundRoute from './routes/notFoundRoute/notFoundRoute';
import registrationRoute from './routes/registrationRoute/registrationRoute';
import forgotPasswordRoute from './routes/forgotPasswordRoute/forgotPasswordRoute';
import confirmRegistrationRoute from './routes/confirmRegistrationRoute/confirmRegistrationRoute';
import logoutRoute from './routes/logoutRoute/logoutRoute';
import forgotPasswordConfirmRoute from './routes/forgotPasswordConfirmRoute/forgotPasswordConfirmRoute';
import loginFederatedRoute from './routes/loginFederatedRoute/loginFederatedRoute';
import logoutFederatedRoute from './routes/logoutFederatedRoute/logoutFederatedRoute';
import errorRoute from './routes/errorRoute/errorRoute';
import otpRoute from './routes/otpRoute/otpRoute';

const routes: Array<RouteRecordRaw> = [
  otpRoute,
  notFoundRoute,
  loginRoute,
  registrationRoute,
  forgotPasswordRoute,
  confirmRegistrationRoute,
  logoutRoute,
  forgotPasswordConfirmRoute,
  loginFederatedRoute,
  logoutFederatedRoute,
  errorRoute
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(beforeEachRoute);

export default router;
